import { getDataClient } from "@/lib/dataClient";
import type { ChatAttachment } from "@/components/feature/live-class/types";

const BUCKET = "live-class-uploads";
const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

/** İzin verilen MIME türleri (güvenlik için) */
const ALLOWED_MIME = new Set([
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "application/zip",
]);

export function isImageMime(mime?: string): boolean {
  if (!mime) return false;
  return mime.startsWith("image/");
}

/**
 * Sohbet eki olarak gönderilecek dosyayı dataClient Storage'a yükler.
 * Başarılı olursa ek bilgisini (url + meta) döner.
 */
export async function uploadChatAttachment(
  file: File,
  onProgress?: (percent: number) => void
): Promise<ChatAttachment> {
  const dataClient = getDataClient();

  if (file.size > MAX_SIZE) {
    throw new Error("Dosya 10 MB sınırını aşıyor.");
  }

  if (!ALLOWED_MIME.has(file.type)) {
    throw new Error("Bu dosya türü desteklenmiyor.");
  }

  // Çakışmayı önlemek için benzersiz, güvenli dosya adı üret
  const ext = file.name.split(".").pop()?.toLowerCase() || "bin";
  const safeName = file.name
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, "-")
    .slice(0, 80);
  const unique = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const path = `${unique}-${safeName || `dosya.${ext}`}`;

  const { data, error } = await dataClient.storage
    .from(BUCKET)
    .upload(path, file, {
      cacheControl: "3600",
      upsert: false,
      contentType: file.type,
    });

  if (error) {
    throw new Error(error.message || "Dosya yüklenemedi.");
  }

  const { data: urlData } = dataClient.storage.from(BUCKET).getPublicUrl(data.path);

  if (onProgress) onProgress(100);

  return {
    kind: isImageMime(file.type) ? "image" : "file",
    url: urlData.publicUrl,
    name: file.name,
    mimeType: file.type,
    size: file.size,
  };
}